import axios from "axios";

export const getMapCenter = (setMapcenter, markerList) => {
  if (!markerList || markerList?.length === 0) {
    return;
  }
  const filterData = markerList.filter((data) => data.position);

  const totalMarkers = filterData?.length;
  let totalLat = 0;
  let totalLng = 0;
  filterData.forEach((marker) => {
    // Backend returns lat/lng as strings from LocationHistory — always parse to float
    const lat = parseFloat(marker?.position?.lat);
    const lng = parseFloat(marker?.position?.lng);
    if (!isNaN(lat) && !isNaN(lng)) {
      totalLat += lat;
      totalLng += lng;
    }
  });

  const centerLat = totalLat / totalMarkers;
  const centerLng = totalLng / totalMarkers;

  setMapcenter({
    lat: centerLat,
    lng: centerLng,
  });
};

export const fetchLocation = (code, setLocation) => {
  const mapkey = process.env.REACT_APP_GOOGLE_MAP_KEY;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${code}&region=in&key=${mapkey}`;
  axios
    .get(url, {
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/json",
      },
    })
    .then((res) => {
      if (res.data.results[0]) {
        const addressComponents = res.data.results[0].address_components;
        let city = addressComponents[1].long_name;
        let state = addressComponents[2].long_name;
        const loca = `${city}, ${state}`;
        setLocation(loca);
      }
    })
    .catch((err) => {
      console.log("err", err);
    });
};

export function filterLocationsWithinDistance(locations, maxDistance) {
  if (locations?.length < 2) {
    return locations;
  }

  const filteredLocations = [locations[0]];

  for (let i = 1; i < locations?.length; i++) {
    const currentLocation = locations[i];
    const previousLocation = filteredLocations[filteredLocations?.length - 1];

    const distance = calculateDistance(
      currentLocation.lat,
      currentLocation.lng,
      previousLocation.lat,
      previousLocation.lng,
    );

    if (distance >= maxDistance) {
      filteredLocations.push(currentLocation);
    }
  }

  return filteredLocations;
}

export function calculateDistance(lat1, lng1, lat2, lng2) {
  const earthRadius = 6371000;
  const lat1Rad = (lat1 * Math.PI) / 180;
  const lat2Rad = (lat2 * Math.PI) / 180;
  const dLat = lat2Rad - lat1Rad;
  const dLng = ((lng2 - lng1) * Math.PI) / 180;

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(lat1Rad) *
      Math.cos(lat2Rad) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const distance = earthRadius * c;

  return distance;
}

export const fetchUserLocation = async (latitude) => {
  const defaultLongitude = 76.9725026;
  const mapkey = process.env.REACT_APP_GOOGLE_MAP_KEY;

  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${defaultLongitude}&key=${mapkey}`;

  try {
    const res = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (res.data?.results?.length > 0) {
      const formattedAddress = res.data.results[0]?.formatted_address;

      return formattedAddress || "Address not found";
    } else {
      return "Location not found";
    }
  } catch (err) {
    console.error("Error fetching user location:", err.message || err);
    return "Error fetching location";
  }
};
